var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Env from '../env';
var compareSymbol = ['>', '<', , '=', '<=', '>='];
var isCompareSymbol = function (value) {
    return compareSymbol.includes(value);
};
function compareVersion(v1, comp, v2) {
    if (comp !== undefined && v2 !== undefined && isCompareSymbol(comp)) {
        return compare(v1, comp, v2);
    }
    if (comp !== undefined && isCompareSymbol(v1)) {
        return compare(Env.appVersion, v1, comp);
    }
    var matches = /\s*([\d.]*)\s*([>=<]+)\s*([\d.]+)\s*/.exec(v1);
    return compare(matches[1] || Env.appVersion, matches[2], matches[3]);
}
function compare(v1, comp, v2) {
    v1 = parseVersion(v1) + '';
    v2 = parseVersion(v2) + '';
    if (comp.match(/[<=>]+/)) {
        return (0, eval)(v1 + comp + v2);
    }
}
// 将形如13.1.22.1的版本号转换为13012201的数字，用于比较
function parseVersion(version) {
    var ret = [];
    var num;
    version = version || '';
    version = version.split('.');
    version.length = 4;
    for (var i = 0; i < version.length; i++) {
        num = +version[i];
        if (num) {
            ret.push(num >= 10 ? num : '0' + num);
        }
        else {
            ret.push('00');
        }
    }
    return parseInt(ret.join(''), 10);
}
/**
 * 指定时间内执行函数，该函数只能被执行一次
 * @param {*} fn 待执行函数
 * @param {*} time 指定时间
 * @param {*} defaultVal 默认回调值
 * @param {*} context 执行上下文
 */
function onceIn(fn, time, defaultVal, context) {
    var _this = this;
    if (defaultVal === void 0) { defaultVal = {}; }
    var called = false;
    setTimeout(function () {
        if (!called) {
            called = true;
            fn.apply(context || _this, [defaultVal]);
        }
    }, time);
    return function () {
        if (!called) {
            called = true;
            // eslint-disable-next-line prefer-rest-params
            fn.apply(context || this, arguments);
        }
    };
}
function registerJsHandler(callbackName, callback) {
    if (callbackName === void 0) { callbackName = ''; }
    callbackName = callbackName + new Date().getTime();
    if (Env.isIOSApp) {
        if (window.DidiJSBridge) {
            window.DidiJSBridge.registerHandler(callbackName, callback);
        }
        else {
            document.addEventListener('DidiJSBridgeReady', function () {
                window.DidiJSBridge.registerHandler(callbackName, callback);
            });
        }
    }
    else if (Env.isAndroidApp) {
        window[callbackName] = callback;
    }
    return callbackName;
}
function mergeConfig(config, config2) {
    var newConfig = __assign({}, config);
    Object.keys(config2).forEach(function (v) {
        // 覆盖默认的support
        newConfig[v] = Object.assign({}, newConfig[v], config2[v]);
    });
    return newConfig;
}
export { compareVersion, registerJsHandler, onceIn, mergeConfig };
